module.exports = __webpack_public_path__ + "img/step-16.bd3c2a66.jpg";